import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SEO from './SEO'
import { buildCanonicalUrl } from '../lib/site'

const STATIC_ROUTES: Record<string, { titleKey: string; descriptionKey: string }> = {
  '/': { titleKey: 'seo.home.title', descriptionKey: 'seo.home.description' },
  '/about': { titleKey: 'seo.about.title', descriptionKey: 'seo.about.description' },
  '/services': { titleKey: 'seo.services.title', descriptionKey: 'seo.services.description' },
  '/contact': { titleKey: 'seo.contact.title', descriptionKey: 'seo.contact.description' },
  '/vacancy': { titleKey: 'seo.vacancies.title', descriptionKey: 'seo.vacancies.description' },
  '/projects': { titleKey: 'seo.projects.title', descriptionKey: 'seo.projects.description' },
  '/privacy-policy': { titleKey: 'seo.privacy.title', descriptionKey: 'seo.privacy.description' },
  '/terms': { titleKey: 'seo.terms.title', descriptionKey: 'seo.terms.description' },
}

const PageSEO = () => {
  const { pathname } = useLocation()
  const { t, i18n } = useTranslation()

  const config = STATIC_ROUTES[pathname]
  if (!config) return null

  const lang = i18n.resolvedLanguage ?? i18n.language

  return (
    <SEO
      title={t(config.titleKey)}
      description={t(config.descriptionKey)}
      keywords={t('seo.keywords')}
      canonical={buildCanonicalUrl(pathname)}
      lang={lang}
    />
  )
}

export default PageSEO
